export default {
  data() {
    return {
      tableColumns: [] //表格列
    };
  },
  methods: {
    buildTableColumns(columns = []) {
      if (columns.length > 0) {
        this.tableColumns = columns;
      } else {
        this.tableColumns = [
          {
            prop: "nameCn",
            label: "中文名",
            minWidth: 150,
            showColumn: true,
            align: "left",
            fixed: "left",
            sortable: "custom"
          },
          {
            prop: "thumbnailUrl",
            label: "缩略图",
            showColumn: true,
            width: 100,
            align: "center",
            sortable: "custom"
          },

          // {
          //   prop: "nameEn",
          //   label: "英文名",
          //   minWidth: 130,
          //   showColumn: true,
          //   align: "left",
          //   sortable: "custom",
          // },

          {
            prop: "code",
            label: "产品编号",
            minWidth: 110,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          // {
          //   prop: "seriesCode",
          //   label: "系列编号",
          //   width: 110,
          //   showColumn: true,
          //   align: "center",
          //   sortable: "custom",
          // },
          {
            prop: "seriesNameCn",
            label: "系列",
            minWidth: 150,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "colorNameCn",
            label: "颜色",
            width: 130,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },

          {
            prop: "onelineDescription",
            label: "一句话描述",
            minWidth: 180,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },

          {
            prop: "cover_image_url",
            label: "效果图",
            showColumn: true,
            width: 100,
            align: "center",
            sortable: "custom"
          },

          {
            prop: "qrcode",
            label: "小程序码",
            showColumn: true,
            width: 120,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "promotionTypeName",
            label: "优惠",
            showColumn: true,
            width: 100,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "seq",
            label: "次序",
            width: 80,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "miniAppIndexSeq",
            label: "小程序首页排序",
            width: 80,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "disabled",
            label: "状态",
            showColumn: true,
            width: 100,
            align: "center",

            sortable: "custom"
          },
          {
            prop: "user_name_create",
            label: "创建人",
            width: 100,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "utc_create",
            label: "创建时间",
            width: 120,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "user_name_modified",
            label: "更新人",
            width: 100,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "utc_modified",
            label: "更新时间",
            showColumn: true,
            width: 120,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "id",
            label: "ID",
            width: 80,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "controlColumn",
            fixed: "right",
            align: "center",
            showColumn: true,
            label: "操作",
            width: 130
          }
        ];
      }
    }
  }
};
